export default {"src":"/_next/static/media/Arrow.15577376.svg","height":24,"width":24};